module.exports = __webpack_public_path__ + "img/map_2.b2790560.png";